import React from 'react';

export function useSortable(defaultName: string, defaultDir = 'ASC') {
    const [sort, setSort] = React.useState({ field: defaultName, dir: defaultDir });

    function updateSort(field: string, invert: boolean) {
        setSort((prev) => {
            const resort = { field, dir: '' };
            if (field === prev.field) {
                resort.dir = prev.dir === 'ASC' ? 'DESC' : 'ASC';
            } else {
                resort.dir = invert ? 'DESC' : 'ASC';
            }
            return resort;
        });
    }

    // invert will make desc the default for that field
    function showSortHeader(field: string, label = '', invert = false) {
        return (
            <th className="cursor-pointer" onClick={() => updateSort(field, invert)}>
                {label || field}{' '}
                {sort.field === field && (
                    <i className={`fa-solid fa-chevron-${sort.dir === 'ASC' ? 'up' : 'down'}`} />
                )}
            </th>
        );
    }

    return { sort, updateSort, showSortHeader };
}
